/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckQuestionSampleImage } from './PaxCheckQuestionSampleImage';
import {
    PaxCheckQuestionSampleImageFromJSON,
    PaxCheckQuestionSampleImageFromJSONTyped,
    PaxCheckQuestionSampleImageToJSON,
    PaxCheckQuestionSampleImageToJSONTyped,
} from './PaxCheckQuestionSampleImage';
import type { PaxCheckQuestionTitle } from './PaxCheckQuestionTitle';
import {
    PaxCheckQuestionTitleFromJSON,
    PaxCheckQuestionTitleFromJSONTyped,
    PaxCheckQuestionTitleToJSON,
    PaxCheckQuestionTitleToJSONTyped,
} from './PaxCheckQuestionTitle';

/**
 * A Yes/No question (boolean)
 * @export
 * @interface PaxCheckDeclarationItem
 */
export interface PaxCheckDeclarationItem {
    /**
     * Question/Declaration item id
     * @type {string}
     * @memberof PaxCheckDeclarationItem
     */
    id: string;
    /**
     * Whether question is relevant for this passenger, according to current answers to all questions
     * @type {boolean}
     * @memberof PaxCheckDeclarationItem
     */
    isRelevant: boolean;
    /**
     * Declaration answer (confirm/refute), if was provided
     * @type {boolean}
     * @memberof PaxCheckDeclarationItem
     */
    answer?: boolean | null;
    /**
     * Declaration title (localised) - formed in either positive or negative form ('I am' or 'I am not'), depending on declaration
     * @type {PaxCheckQuestionTitle}
     * @memberof PaxCheckDeclarationItem
     */
    questionTitle: PaxCheckQuestionTitle;
    /**
     * 
     * @type {PaxCheckQuestionSampleImage}
     * @memberof PaxCheckDeclarationItem
     */
    sampleImage?: PaxCheckQuestionSampleImage | null;
    /**
     * Stable machine-readable marker for a declaration whose id is otherwise opaque - currently only set for the single-window onward-flight declaration, using the same value as PickFromListQuestion.TYPE.ONWARD_FLIGHT.id
     * @type {string}
     * @memberof PaxCheckDeclarationItem
     */
    kind?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaxCheckDeclarationItem
     */
    defaultValue: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckDeclarationItem
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckDeclarationItem interface.
 */
export function instanceOfPaxCheckDeclarationItem(value: object): value is PaxCheckDeclarationItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isRelevant' in value) || value['isRelevant'] === undefined) return false;
    if (!('questionTitle' in value) || value['questionTitle'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckDeclarationItemFromJSON(json: any): PaxCheckDeclarationItem {
    return PaxCheckDeclarationItemFromJSONTyped(json, false);
}

export function PaxCheckDeclarationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDeclarationItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isRelevant': json['is_relevant'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'questionTitle': PaxCheckQuestionTitleFromJSON(json['question_title']),
        'sampleImage': json['sample_image'] == null ? undefined : PaxCheckQuestionSampleImageFromJSON(json['sample_image']),
        'kind': json['kind'] == null ? undefined : json['kind'],
        'defaultValue': json['default_value'],
        'type': json['type'],
    };
}

export function PaxCheckDeclarationItemToJSON(json: any): PaxCheckDeclarationItem {
    return PaxCheckDeclarationItemToJSONTyped(json, false);
}

export function PaxCheckDeclarationItemToJSONTyped(value?: PaxCheckDeclarationItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'is_relevant': value['isRelevant'],
        'answer': value['answer'],
        'question_title': PaxCheckQuestionTitleToJSON(value['questionTitle']),
        'sample_image': PaxCheckQuestionSampleImageToJSON(value['sampleImage']),
        'kind': value['kind'],
        'default_value': value['defaultValue'],
        'type': value['type'],
    };
}

